<template>
  <div class="error-page">
    <div class="container">
        <div class="error-page flex flex-col lg:flex-row items-center justify-center h-screen text-center lg:text-left">
           <div class="-intro-x lg:mr-20"><img alt="Midone Tailwind HTML Admin Template" class="h-48 lg:h-auto" :src="image"></div>
            <div class="text-white mt-10 lg:mt-0">
                <div class="intro-x text-8xl font-medium">404</div>
                <div class="intro-x text-xl lg:text-3xl font-medium mt-5"> Oops. This page has gone missing. </div>
                <div class="intro-x text-lg mt-3"> You may have mistyped the address or the page may have moved. </div>
                <router-link  :to="'/?typeuser='+user.type"><button class="intro-x btn py-3 px-4 text-white border-white dark:border-darkmode-400 dark:text-slate-200 mt-10"> Back to Home </button></router-link>
            </div>
        </div>
    </div>
    
  </div>
</template>
<script>
import image from "@/assets/404_2.png";
export default {
    data() {
    return {
      image: image,
        user: {role: {},},
    };
  },
   async mounted() {
      this.getUser();
   },
    methods: {
       async getUser() {
            const res = await this.$server.me("users");
            if (res.content) {
                this.user = res.content;
            }
            },
    }
}    
</script>    
<style scoped>
.container {
 width:100%;
 margin-right:auto;
 margin-left:auto
}
.btn {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: .375rem;
  border-width: 1px;
  padding: .5rem .75rem;
  font-weight: 500;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);
  transition-property: color,background-color,border-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-text-decoration-color,-webkit-backdrop-filter;
  transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;
  transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-text-decoration-color,-webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(.4,0,.2,1);
  transition-duration: .2s;
}
.error-page{
    background: #1e40af;
}
.font-medium {
  font-weight: 500;
}
.text-8xl {
  font-size: 6rem;
  line-height: 1;
}
@media (min-width: 640px) {
 .container {
  max-width:640px
 }
}
@media (min-width: 768px) {
 .container {
  max-width:768px
 }
}
@media (min-width: 1024px) {
 .container {
  max-width:1024px
 }
}
@media (min-width: 1280px) {
 .container {
  max-width:1280px
 }
}
@media (min-width: 1536px) {
 .container {
  max-width:1536px
 }
}
.error-page img {
  width: 450px;
}

@media (min-width: 640px) {
 .sm\:static {
  position:static
 }
 .sm\:absolute {
  position:absolute
 }
 .sm\:relative {
  position:relative
 }
 .sm\:col-span-6 {
  grid-column:span 6 / span 6
 }
 .sm\:col-span-4 {
  grid-column:span 4 / span 4
 }
 .sm\:col-span-3 {
  grid-column:span 3 / span 3
 }
 .sm\:col-span-1 {
  grid-column:span 1 / span 1
 }
 .sm\:-mx-8 {
  margin-left:-2rem;
  margin-right:-2rem
 }
 .sm\:mx-0 {
  margin-left:0;
  margin-right:0
 }
 .sm\:mx-2 {
  margin-left:.5rem;
  margin-right:.5rem
 }
 .sm\:mr-6 {
  margin-right:1.5rem
 }
 .sm\:ml-auto {
  margin-left:auto
 }
 .sm\:mt-0 {
  margin-top:0
 }
 .sm\:\!mr-10 {
  margin-right:2.5rem!important
 }
 .sm\:ml-0 {
  margin-left:0
 }
 .sm\:mr-auto {
  margin-right:auto
 }
 .sm\:mr-3 {
  margin-right:.75rem
 }
 .sm\:ml-3 {
  margin-left:.75rem
 }
 .sm\:mb-0 {
  margin-bottom:0
 }
 .sm\:mr-5 {
  margin-right:1.25rem
 }
 .sm\:mt-5 {
  margin-top:1.25rem
 }
 .sm\:mt-2 {
  margin-top:.5rem
 }
 .sm\:mt-10 {
  margin-top:2.5rem
 }
 .sm\:ml-40 {
  margin-left:10rem
 }
 .sm\:mr-28 {
  margin-right:7rem
 }
 .sm\:mr-40 {
  margin-right:10rem
 }
 .sm\:mr-20 {
  margin-right:5rem
 }
 .sm\:mr-0 {
  margin-right:0
 }
 .sm\:mr-2 {
  margin-right:.5rem
 }
 .sm\:ml-20 {
  margin-left:5rem
 }
 .sm\:mr-4 {
  margin-right:1rem
 }
 .sm\:ml-1 {
  margin-left:.25rem
 }
 .sm\:ml-2 {
  margin-left:.5rem
 }
 .sm\:block {
  display:block
 }
 .sm\:flex {
  display:flex
 }
 .sm\:grid {
  display:grid
 }
 .sm\:hidden {
  display:none
 }
 .sm\:h-10 {
  height:2.5rem
 }
 .sm\:h-12 {
  height:3rem
 }
 .sm\:h-5 {
  height:1.25rem
 }
 .sm\:h-24 {
  height:6rem
 }
 .sm\:w-auto {
  width:auto
 }
 .sm\:w-20 {
  width:5rem
 }
 .sm\:w-10 {
  width:2.5rem
 }
 .sm\:w-12 {
  width:3rem
 }
 .sm\:w-5 {
  width:1.25rem
 }
 .sm\:w-56 {
  width:14rem
 }
 .sm\:w-72 {
  width:18rem
 }
 .sm\:w-52 {
  width:13rem
 }
 .sm\:w-60 {
  width:15rem
 }
 .sm\:w-full {
  width:100%
 }
 .sm\:w-64 {
  width:16rem
 }
 .sm\:w-3\/4 {
  width:75%
 }
 .sm\:w-40 {
  width:10rem
 }
 .sm\:w-24 {
  width:6rem
 }
 .sm\:w-32 {
  width:8rem
 }
 .sm\:w-16 {
  width:4rem
 }
 .sm\:flex-row {
  flex-direction:row
 }
 .sm\:flex-nowrap {
  flex-wrap:nowrap
 }
 .sm\:items-end {
  align-items:flex-end
 }
 .sm\:justify-start {
  justify-content:flex-start
 }
 .sm\:justify-end {
  justify-content:flex-end
 }
 .sm\:gap-10 {
  gap:2.5rem
 }
 .sm\:gap-6 {
  gap:1.5rem
 }
 .sm\:overflow-x-visible {
  overflow-x:visible
 }
 .sm\:whitespace-normal {
  white-space:normal
 }
 .sm\:border-0 {
  border-width:0px
 }
 .sm\:border-t-0 {
  border-top-width:0px
 }
 .sm\:border-l {
  border-left-width:1px
 }
 .sm\:border-b-0 {
  border-bottom-width:0px
 }
 .sm\:px-8 {
  padding-left:2rem;
  padding-right:2rem
 }
 .sm\:px-0 {
  padding-left:0;
  padding-right:0
 }
 .sm\:py-4 {
  padding-top:1rem;
  padding-bottom:1rem
 }
 .sm\:px-28 {
  padding-left:7rem;
  padding-right:7rem
 }
 .sm\:px-5 {
  padding-left:1.25rem;
  padding-right:1.25rem
 }
 .sm\:px-20 {
  padding-left:5rem;
  padding-right:5rem
 }
 .sm\:py-20 {
  padding-top:5rem;
  padding-bottom:5rem
 }
 .sm\:px-16 {
  padding-left:4rem;
  padding-right:4rem
 }
 .sm\:px-10 {
  padding-left:2.5rem;
  padding-right:2.5rem
 }
 .sm\:py-0 {
  padding-top:0;
  padding-bottom:0
 }
 .sm\:py-3 {
  padding-top:.75rem;
  padding-bottom:.75rem
 }
 .sm\:pt-6 {
  padding-top:1.5rem
 }
 .sm\:pt-0 {
  padding-top:0
 }
 .sm\:pl-5 {
  padding-left:1.25rem
 }
 .sm\:pb-20 {
  padding-bottom:5rem
 }
 .sm\:pt-20 {
  padding-top:5rem
 }
 .sm\:pb-0 {
  padding-bottom:0
 }
 .sm\:text-left {
  text-align:left
 }
 .sm\:text-right {
  text-align:right
 }
 .sm\:text-sm {
  font-size:.875rem;
  line-height:1.25rem
 }
 .sm\:text-2xl {
  font-size:1.5rem;
  line-height:2rem
 }
 .sm\:text-lg {
  font-size:1.125rem;
  line-height:1.75rem
 }
}
@media (min-width: 768px) {
 .md\:col-span-2 {
  grid-column:span 2 / span 2
 }
 .md\:col-span-6 {
  grid-column:span 6 / span 6
 }
 .md\:col-span-4 {
  grid-column:span 4 / span 4
 }
 .md\:col-span-3 {
  grid-column:span 3 / span 3
 }
 .md\:row-start-auto {
  grid-row-start:auto
 }
 .md\:mt-0 {
  margin-top:0
 }
 .md\:-mt-5 {
  margin-top:-1.25rem
 }
 .md\:ml-0 {
  margin-left:0
 }
 .md\:ml-auto {
  margin-left:auto
 }
 .md\:block {
  display:block
 }
 .md\:flex {
  display:flex
 }
 .md\:hidden {
  display:none
 }
 .md\:w-52 {
  width:13rem
 }
 .md\:flex-row {
  flex-direction:row
 }
 .md\:items-center {
  align-items:center
 }
 .md\:border-t-0 {
  border-top-width:0px
 }
 .md\:border-l {
  border-left-width:1px
 }
 .md\:border-r {
  border-right-width:1px
 }
 .md\:border-l-0 {
  border-left-width:0px
 }
 .md\:px-5 {
  padding-left:1.25rem;
  padding-right:1.25rem
 }
 .md\:pt-0 {
  padding-top:0
 }
 .md\:pl-0 {
  padding-left:0
 }
}
@media (min-width: 1024px) {
 .lg\:col-span-6 {
  grid-column:span 6 / span 6
 }
 .lg\:col-span-4 {
  grid-column:span 4 / span 4
 }
 .lg\:col-span-8 {
  grid-column:span 8 / span 8
 }
 .lg\:col-span-3 {
  grid-column:span 3 / span 3
 }
 .lg\:col-span-9 {
  grid-column:span 9 / span 9
 }
 .lg\:col-span-2 {
  grid-column:span 2 / span 2
 }
 .lg\:col-span-7 {
  grid-column:span 7 / span 7
 }
 .lg\:row-start-3 {
  grid-row-start:3
 }
 .lg\:mx-auto {
  margin-left:auto;
  margin-right:auto
 }
 .lg\:mt-5 {
  margin-top:1.25rem
 }
 .lg\:mt-6 {
  margin-top:1.5rem
 }
 .lg\:mr-20 {
  margin-right:5rem
 }
 .lg\:mt-0 {
  margin-top:0
 }
 .lg\:ml-auto {
  margin-left:auto
 }
 .lg\:ml-5 {
  margin-left:1.25rem
 }
 .lg\:mb-0 {
  margin-bottom:0
 }
 .lg\:ml-8 {
  margin-left:2rem
 }
 .lg\:mt-3 {
  margin-top:.75rem
 }
 .lg\:mr-1 {
  margin-right:.25rem
 }
 .lg\:ml-2 {
  margin-left:.5rem
 }
 .lg\:mr-auto {
  margin-right:auto
 }
 .lg\:ml-0 {
  margin-left:0
 }
 .lg\:ml-4 {
  margin-left:1rem
 }
 .lg\:block {
  display:block
 }
 .lg\:flex {
  display:flex
 }
 .lg\:h-auto {
  height:auto
 }
 .lg\:h-32 {
  height:8rem
 }
 .lg\:h-12 {
  height:3rem
 }
 .lg\:w-auto {
  width:auto
 }
 .lg\:w-2\/4 {
  width:50%
 }
 .lg\:w-64 {
  width:16rem
 }
 .lg\:w-40 {
  width:10rem
 }
 .lg\:w-32 {
  width:8rem
 }
 .lg\:w-56 {
  width:14rem
 }
 .lg\:w-12 {
  width:3rem
 }
 .lg\:w-1\/2 {
  width:50%
 }
 .lg\:flex-row {
  flex-direction:row
 }
 .lg\:flex-nowrap {
  flex-wrap:nowrap
 }
 .lg\:items-start {
  align-items:flex-start
 }
 .lg\:justify-start {
  justify-content:flex-start
 }
 .lg\:justify-end {
  justify-content:flex-end
 }
 .lg\:justify-center {
  justify-content:center
 }
 .lg\:overflow-visible {
  overflow:visible
 }
 .lg\:border-0 {
  border-width:0px
 }
 .lg\:border-t-0 {
  border-top-width:0px
 }
 .lg\:border-l {
  border-left-width:1px
 }
 .lg\:border-b-0 {
  border-bottom-width:0px
 }
 .lg\:border-r {
  border-right-width:1px
 }
 .lg\:px-6 {
  padding-left:1.5rem;
  padding-right:1.5rem
 }
 .lg\:py-3 {
  padding-top:.75rem;
  padding-bottom:.75rem
 }
 .lg\:px-5 {
  padding-left:1.25rem;
  padding-right:1.25rem
 }
 .lg\:pb-0 {
  padding-bottom:0
 }
 .lg\:pl-5 {
  padding-left:1.25rem
 }
 .lg\:pb-20 {
  padding-bottom:5rem
 }
 .lg\:pt-0 {
  padding-top:0
 }
 .lg\:text-left {
  text-align:left
 }
 .lg\:text-center {
  text-align:center
 }
 .lg\:text-right {
  text-align:right
 }
 .lg\:text-justify {
  text-align:justify
 }
 .lg\:text-3xl {
  font-size:1.875rem;
  line-height:2.25rem
 }

}
@media (min-width: 1280px) {
 .xl\:absolute {
  position:absolute
 }
 .xl\:sticky {
  position:-webkit-sticky;
  position:sticky
 }
 .xl\:z-auto {
  z-index:auto
 }
 .xl\:col-span-4 {
  grid-column:span 4 / span 4
 }
 .xl\:col-span-8 {
  grid-column:span 8 / span 8
 }
 .xl\:col-span-3 {
  grid-column:span 3 / span 3
 }
 .xl\:col-span-12 {
  grid-column:span 12 / span 12
 }
 .xl\:col-span-6 {
  grid-column:span 6 / span 6
 }
 .xl\:col-span-9 {
  grid-column:span 9 / span 9
 }
 .xl\:col-span-1 {
  grid-column:span 1 / span 1
 }
 .xl\:col-span-2 {
  grid-column:span 2 / span 2
 }
 .xl\:col-start-1 {
  grid-column-start:1
 }
 .xl\:col-start-10 {
  grid-column-start:10
 }
 .xl\:row-start-1 {
  grid-row-start:1
 }
 .xl\:row-start-2 {
  grid-row-start:2
 }
 .xl\:row-start-auto {
  grid-row-start:auto
 }
 .xl\:mx-5 {
  margin-left:1.25rem;
  margin-right:1.25rem
 }
 .xl\:mx-6 {
  margin-left:1.5rem;
  margin-right:1.5rem
 }
 .xl\:my-0 {
  margin-top:0;
  margin-bottom:0
 }
 .xl\:\!mr-10 {
  margin-right:2.5rem!important
 }
 .xl\:mt-0 {
  margin-top:0
 }
 .xl\:ml-5 {
  margin-left:1.25rem
 }
 .xl\:ml-20 {
  margin-left:5rem
 }
 .xl\:ml-64 {
  margin-left:16rem
 }
 .xl\:ml-auto {
  margin-left:auto
 }
 .xl\:mt-2 {
  margin-top:.5rem
 }
 .xl\:-mt-5 {
  margin-top:-1.25rem
 }
 .xl\:mt-8 {
  margin-top:2rem
 }
 .xl\:mr-3 {
  margin-right:.75rem
 }
 .xl\:mt-24 {
  margin-top:6rem
 }
 .xl\:mr-0 {
  margin-right:0
 }
 .xl\:ml-6 {
  margin-left:1.5rem
 }
 .xl\:block {
  display:block
 }
 .xl\:flex {
  display:flex
 }
 .xl\:grid {
  display:grid
 }
 .xl\:hidden {
  display:none
 }
 .xl\:h-auto {
  height:auto
 }
 .xl\:min-h-0 {
  min-height:0px
 }
 .xl\:w-64 {
  width:16rem
 }
 .xl\:w-3\/5 {
  width:60%
 }
 .xl\:w-auto {
  width:auto
 }
 .xl\:w-32 {
  width:8rem
 }
 .xl\:flex-initial {
  flex:0 1 auto
 }
 .xl\:flex-row {
  flex-direction:row
 }
 .xl\:flex-nowrap {
  flex-wrap:nowrap
 }
 .xl\:items-start {
  align-items:flex-start
 }
 .xl\:overflow-y-auto {
  overflow-y:auto
 }
 .xl\:bg-transparent {
  background-color:transparent
 }
 .xl\:p-0 {
  padding:0
 }
 .xl\:px-0 {
  padding-left:0;
  padding-right:0
 }
 .xl\:py-0 {
  padding-top:0;
  padding-bottom:0
 }
 .xl\:pr-10 {
  padding-right:2.5rem
 }
 .xl\:pr-20 {
  padding-right:5rem
 }
 .xl\:pl-5 {
  padding-left:1.25rem
 }
 .xl\:pl-10 {
  padding-left:2.5rem
 }
 .xl\:pb-0 {
  padding-bottom:0
 }
 .xl\:pb-16 {
  padding-bottom:4rem
 }
 .xl\:text-left {
  text-align:left
 }
 .xl\:text-right {
  text-align:right
 }
 .xl\:text-xl {
  font-size:1.25rem;
  line-height:1.75rem
 }
 .xl\:text-3xl {
  font-size:1.875rem;
  line-height:2.25rem
 }
}
@media (min-width: 1536px) {
 .\32xl\:z-10 {
  z-index:10
 }
 .\32xl\:col-span-9 {
  grid-column:span 9 / span 9
 }
 .\32xl\:col-span-3 {
  grid-column:span 3 / span 3
 }
 .\32xl\:col-span-12 {
  grid-column:span 12 / span 12
 }
 .\32xl\:col-span-2 {
  grid-column:span 2 / span 2
 }
 .\32xl\:col-span-10 {
  grid-column:span 10 / span 10
 }
 .\32xl\:col-span-5 {
  grid-column:span 5 / span 5
 }
 .\32xl\:col-span-6 {
  grid-column:span 6 / span 6
 }
 .\32xl\:col-span-8 {
  grid-column:span 8 / span 8
 }
 .\32xl\:col-span-4 {
  grid-column:span 4 / span 4
 }
 .\32xl\:col-start-auto {
  grid-column-start:auto
 }
 .\32xl\:row-start-auto {
  grid-row-start:auto
 }
 .\32xl\:mt-8 {
  margin-top:2rem
 }
 .\32xl\:mt-6 {
  margin-top:1.5rem
 }
 .\32xl\:mt-24 {
  margin-top:6rem
 }
 .\32xl\:mt-0 {
  margin-top:0
 }
 .\32xl\:ml-16 {
  margin-left:4rem
 }
 .\32xl\:-ml-20 {
  margin-left:-5rem
 }
 .\32xl\:mb-0 {
  margin-bottom:0
 }
 .\32xl\:-mt-1\.5 {
  margin-top:-.375rem
 }
 .\32xl\:-mt-1 {
  margin-top:-.25rem
 }
 .\32xl\:mr-auto {
  margin-right:auto
 }
 .\32xl\:-mt-8 {
  margin-top:-2rem
 }
 .\32xl\:block {
  display:block
 }
 .\32xl\:flex {
  display:flex
 }
 .\32xl\:h-56 {
  height:14rem
 }
 .\32xl\:w-14 {
  width:3.5rem
 }
 .\32xl\:w-52 {
  width:13rem
 }
 .\32xl\:w-4\/6,
 .\32xl\:w-2\/3 {
  width:66.666667%
 }
 .\32xl\:w-full {
  width:100%
 }
 .\32xl\:flex-none {
  flex:none
 }
 .\32xl\:grid-cols-7 {
  grid-template-columns:repeat(7,minmax(0,1fr))
 }
 .\32xl\:justify-center {
  justify-content:center
 }
 .\32xl\:gap-x-0 {
  -moz-column-gap:0px;
  column-gap:0px
 }
 .\32xl\:overflow-visible {
  overflow:visible
 }
 .\32xl\:border-l {
  border-left-width:1px
 }
 .\32xl\:bg-transparent {
  background-color:transparent
 }
 .\32xl\:p-0 {
  padding:0
 }
 .\32xl\:px-6 {
  padding-left:1.5rem;
  padding-right:1.5rem
 }
 .\32xl\:pl-6 {
  padding-left:1.5rem
 }
 .\32xl\:pt-0 {
  padding-top:0
 }
 .\32xl\:pl-4 {
  padding-left:1rem
 }
 .\32xl\:pl-2\.5 {
  padding-left:.625rem
 }
 .\32xl\:pl-2 {
  padding-left:.5rem
 }
 .\32xl\:text-base {
  font-size:1rem;
  line-height:1.5rem
 }
 .\32xl\:text-lg {
  font-size:1.125rem;
  line-height:1.75rem
 }
 .\32xl\:text-3xl {
  font-size:1.875rem;
  line-height:2.25rem
 }
 .\32xl\:text-2xl {
  font-size:1.5rem;
  line-height:2rem
 }
 .\32xl\:text-sm {
  font-size:.875rem;
  line-height:1.25rem
 }
 .\32xl\:text-xl {
  font-size:1.25rem;
  line-height:1.75rem
 }
 .\32xl\:leading-5 {
  line-height:1.25rem
 }
}

</style>